'use strict';

var _defineProperty = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Node = require('./node');

var Declaration = /*#__PURE__*/function (_Node) {
  _inherits(Declaration, _Node);

  var _super = _createSuper(Declaration);

  function Declaration(defaults) {
    var _this;

    _classCallCheck(this, Declaration);

    if (defaults && typeof defaults.value !== 'undefined' && typeof defaults.value !== 'string') {
      defaults = _objectSpread(_objectSpread({}, defaults), {}, {
        value: String(defaults.value)
      });
    }

    _this = _super.call(this, defaults);
    _this.type = 'decl';
    return _this;
  }

  _createClass(Declaration, [{
    key: "variable",
    get: function get() {
      return this.prop.startsWith('--') || this.prop[0] === '$';
    }
  }]);

  return Declaration;
}(Node);

module.exports = Declaration;
Declaration.default = Declaration;